// toggle-buttons.js
document.addEventListener("DOMContentLoaded", () => {
  console.log("[toggle-buttons.js] DOMContentLoaded");
  const allToggleBtns = document.querySelectorAll(".btn-toggle");

  allToggleBtns.forEach((btn) => {
    // Skip Like/Dislike if they're handled elsewhere
    if (btn.id === "likeBtn" || btn.id === "dislikeBtn") {
      console.log("[toggle-buttons] Skipping:", btn.id);
      return;
    }

    // Check if this button wants to store its state in localStorage
    // e.g. <button class="btn-toggle" data-lskey="bookmarkToggle">
    const lsKey = btn.getAttribute("data-lskey") || null;

    // Check if user wants to force theme (e.g. data-theme-toggle="dark")
    // so we know to apply data-force-theme="dark" when .active
    const themeToggleAttr = btn.getAttribute("data-theme-toggle");
    const forceThemeWhenActive = themeToggleAttr === "dark";

    // This will track the current state in memory
    let isActive = false;

    // -----------------------------
    // 1) READ FROM LOCALSTORAGE (if configured)
    // -----------------------------
    if (lsKey) {
      const storedVal = localStorage.getItem(lsKey);
      if (storedVal === "true") {
        // Mark the button as active on load
        btn.classList.add("active");
        btn.setAttribute("aria-pressed", "true");
        isActive = true;
      }
    }

    // -----------------------------
    // 2) If active on load -> swap icons & apply theme
    // -----------------------------
    applyIconToggle(btn, isActive, forceThemeWhenActive);

    // -----------------------------
    // 3) CLICK LISTENER
    // -----------------------------
    btn.addEventListener("click", () => {
      const wasActive = btn.classList.contains("active");
      const newActiveState = !wasActive;

      btn.classList.toggle("active", newActiveState);
      btn.setAttribute("aria-pressed", newActiveState ? "true" : "false");

      // Swap icons & apply / remove data-force-theme
      applyIconToggle(btn, newActiveState, forceThemeWhenActive);

      // If localStorage key is set, persist
      if (lsKey) {
        localStorage.setItem(lsKey, String(newActiveState));
      }

      console.log("[toggle-buttons] Toggled:", {
        btnId: btn.id,
        newActiveState,
        lsKey,
        forceThemeWhenActive,
      });
    });
  });

  // -----------------------------
  // HELPER: applyIconToggle
  // -----------------------------
  function applyIconToggle(button, isActive, forceThemeWhenActive) {
    // Attempt to find an <img> with data-icon & data-toggled-icon
    const iconEl = button.querySelector("img[data-icon][data-toggled-icon]");
    if (!iconEl) {
      // If no icon, nothing to do
      return;
    }

    // If we haven't stored the original icon, do so now
    if (!iconEl.dataset.iconOff) {
      iconEl.dataset.iconOff = iconEl.getAttribute("data-icon") || "";
    }

    const toggledIcon = iconEl.getAttribute("data-toggled-icon");

    // If going active => use toggled icon
    // If going inactive => revert to original
    const newIcon = isActive ? toggledIcon : iconEl.dataset.iconOff;
    iconEl.setAttribute("data-icon", newIcon);

    // If the user wants `data-force-theme="dark"`, apply when active
    if (forceThemeWhenActive) {
      if (isActive) {
        iconEl.setAttribute("data-force-theme", "dark");
      } else {
        iconEl.removeAttribute("data-force-theme");
      }
    }

    // Re-run your theme logic, if any
    if (typeof window.applyTheme === "function") {
      window.applyTheme();
    }
  }
});
